import { CurrencyPipe } from '@angular/common';
import { Pipe } from '@angular/core';

@Pipe({
    name: 'dsbCurrency',
    standalone: false,
})
// eslint-disable-next-line @angular-eslint/use-pipe-transform-interface
export class DsbCurrencyPipe extends CurrencyPipe {
    override transform(
        value: string | number | undefined,
        currencyCode?: string,
        display?: string | boolean,
        digitsInfo?: string,
        locale?: string
    ): string | null;
    override transform(
        value: null | undefined,
        currencyCode?: string,
        display?: string | boolean,
        digitsInfo?: string,
        locale?: string
    ): null;
    override transform(
        value: string | number | null | undefined,
        currencyCode?: string,
        display?: string | boolean,
        digitsInfo?: string,
        locale?: string
    ): string | null {
        let transformed = super.transform(value, currencyCode, display, digitsInfo, locale);
        if (typeof value === 'number' && !isNaN(value) && digitsInfo === '1.0-2') {
            // For values with .10, .20, etc., ensure two decimal places are shown
            if (transformed && /^.+\.[1-9]$/.test(transformed)) {
                transformed = `${transformed}0`;
            }
        }
        return transformed;
    }
}
